import { LottieAnimationInt, LottieItemInt } from "interfaces";
import lottie from "lottie-web";
import { cloneDeep } from "lodash";

const lottieAnimation = ({ targets, addLottie }: LottieAnimationInt) => {
  const scrollMultiplier = 16,
    total = targets.length;

  lottie.setQuality("low");
  lottie.setLocationHref(window.location.href);

  targets.forEach(function (wrapper: any, index: number) {
    let target = wrapper.querySelector(".lottie-target");
    let playhead = { frame: 0 },
      // ctx = gsap.context && gsap.context(),
      animation: LottieItemInt = lottie.loadAnimation({
        container: target,
        // path: target.dataset.lottie,
        animationData: cloneDeep(
          require(`../lotties/${target.dataset.lottie}.json`)
        ),
        renderer: "svg",
        loop: false,
        autoplay: false,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      });
    animation.addEventListener("DOMLoaded", function () {
      let createTween = () => {
        const transitionDur = 250;

        const response = {
          index: index,
          // tl: tl,
          animation: animation,
          playhead: playhead,
          target: target,
          wrapper: wrapper,
          markers: animation.markers?.map((marker) =>
            total === 1
              ? Math.ceil(marker.time * scrollMultiplier + 0.2 * transitionDur)
              : Math.ceil(marker.time * scrollMultiplier + 2.5 * transitionDur)
          ),
          duration:
            total === 1
              ? animation.totalFrames * scrollMultiplier
              : animation.totalFrames * scrollMultiplier + 2.5 * transitionDur,
        };
        addLottie(response);

        return () => animation.destroy && animation.destroy();
      };
      createTween();
      // ctx && ctx.add ? ctx.add(createTween) : createTween();
    });
  });
};

export default lottieAnimation;
